import React from 'react';
import { Button } from 'antd';

export default function ActionProgressButton({ children, inProgress, ...attrs }) {
  return (
    <Button {...attrs} loading={inProgress} disabled={attrs.disabled || inProgress}>
      {children}
    </Button>
  );
}
